<template>
  <v-container fluid
               class="pa-0"
               :class="{ 'px-1': $vuetify.display.mdAndDown }"
  >
    <DataRoomLayout v-if="isDataRoom" :mnemo="roomMnemo" />
    <ProjectLayout v-else :mnemo="roomMnemo" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import { toast } from '@/common/utils/toast'
import DataRoomLayout from '@/project/project-settings/layouts/DataRoomLayout.vue'
import ProjectLayout from '@/project/project-settings/layouts/ProjectLayout.vue'
import { RESET_ROOM } from '@/store/modules/room/mutation_types'

export default {
  name: 'ProjectSettings',
  components: {
    DataRoomLayout,
    ProjectLayout,
  },
  head () {
    return {
      title: this.$t('project.views.ProjectSettings.metaTitle'),
    }
  },
  computed: {
    ...mapGetters('room', ['isDataRoom', 'roomMnemo']),
    isPm () {
      return this.$store.getters['room/isCurrentUserPm']
    },
  },
  created () {
    if (!this.isPm) {
      toast.error(this.$t('project.views.ProjectSettings.nonExistentProject'))
      this.$router.push('/')
    }
  },
  beforeUnmount () {
    this.$store.commit(`room/${RESET_ROOM}`)
  },
}
</script>
